import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, type FC } from 'react';
import { AdItem, CorrelatedTrackingInfo } from '@sbt-web/network/types';
import { AdDetailCarousel } from '../AdDetailCarousel';
import { useData } from './useData';
interface RelatedAdsProps {
  urn: string;
  apiBase: string;
  userId: Promise<string>;
  useWorker?: boolean;
  onClick?: (item: AdItem, index: number, trackingInfo?: CorrelatedTrackingInfo) => void;
  onVisible?: (items: AdItem[], trackingInfo?: CorrelatedTrackingInfo) => void;
  onLoaded?: (items: AdItem[], trackingInfo?: CorrelatedTrackingInfo) => void;
  className?: string;
}
const labelProps = {
  title: 'Potrebbe interessarti',
  ariaLabel: 'Annunci correlati',
  navigationLabels: {
    right: 'Altri annunci suggeriti',
    left: 'Annunci suggeriti precedenti'
  }
};
const RelatedAds: FC<RelatedAdsProps> = t0 => {
  const $ = _c(20);
  const {
    urn,
    apiBase,
    userId,
    onClick,
    onVisible,
    onLoaded,
    className: t1,
    useWorker: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const useWorker = t2 === undefined ? false : t2;
  const [data, trackingInfo, success, isLoading] = useData(urn, apiBase, userId, useWorker);
  let t3;
  if ($[0] !== data || $[1] !== onVisible || $[2] !== success || $[3] !== trackingInfo) {
    t3 = () => {
      if (success) {
        onVisible?.(data, trackingInfo);
      }
    };
    $[0] = data;
    $[1] = onVisible;
    $[2] = success;
    $[3] = trackingInfo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleOnVisible = t3;
  let t4;
  if ($[5] !== onClick || $[6] !== trackingInfo) {
    t4 = (card, index) => onClick?.(card, index, trackingInfo);
    $[5] = onClick;
    $[6] = trackingInfo;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleOnClick = t4;
  let t5;
  let t6;
  if ($[8] !== data || $[9] !== onLoaded || $[10] !== success || $[11] !== trackingInfo) {
    t5 = () => {
      if (success) {
        onLoaded?.(data, trackingInfo);
      }
    };
    t6 = [onLoaded, success, data, trackingInfo];
    $[8] = data;
    $[9] = onLoaded;
    $[10] = success;
    $[11] = trackingInfo;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== className || $[15] !== data || $[16] !== handleOnClick || $[17] !== handleOnVisible || $[18] !== isLoading) {
    t7 = <AdDetailCarousel data={data} onClick={handleOnClick} onVisible={handleOnVisible} className={className} isLoading={isLoading} {...labelProps} />;
    $[14] = className;
    $[15] = data;
    $[16] = handleOnClick;
    $[17] = handleOnVisible;
    $[18] = isLoading;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export { RelatedAds, labelProps };
export type { RelatedAdsProps };